import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <section
      data-testid="not-found-page"
      className="kremes-texture flex min-h-[60vh] items-center justify-center px-5 py-20 text-center"
    >
      <div className="max-w-xl">
        <p className="font-mono text-7xl font-bold tracking-tighter text-bumbu sm:text-8xl">
          404
        </p>
        <h1 className="mt-4 font-heading text-2xl font-extrabold tracking-tight text-charcoal sm:text-4xl">
          Waduh, sambalnya tumpah! Halaman tidak ditemukan.
        </h1>
        <p className="mt-4 text-base leading-relaxed text-charcoal-muted">
          Alamat yang kamu tuju tidak ada atau sudah dipindah. Seporsi ayam
          goreng basah khas Bandung tetap menunggumu di halaman utama.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/"
            data-testid="not-found-home-button"
            className="rounded-full bg-charcoal px-7 py-3 font-heading text-sm font-bold text-canvas transition-all hover:scale-[1.03] hover:bg-bumbu hover:text-charcoal active:scale-[0.98]"
          >
            Kembali ke Beranda
          </Link>
          <Link
            to="/menu/"
            data-testid="not-found-menu-button"
            className="rounded-full border-2 border-charcoal px-7 py-3 font-heading text-sm font-bold text-charcoal transition-all hover:scale-[1.03] hover:bg-bumbu-light active:scale-[0.98]"
          >
            Lihat Menu
          </Link>
        </div>
      </div>
    </section>
  );
}
